import { TeamWithRoles } from './permissions-table.types';
import { Fragment } from 'react';
import { TeamName } from './team-name';
import './permissions-table.scss';

export const RenderViaTeamDetails = ({ teams }: { teams: TeamWithRoles[] }) => {
  return (
    <span color="primary">
      {teams?.map((team, teamIndex) => (
        <Fragment key={team.team.id}>
          {/* Add opening bracket and via text for first team name */}
          {teamIndex === 0 && '(via - '}
          <TeamName team={team} />
          {/* Add closing bracket for last team name OR else add comma separator */}
          {(teamIndex + 1 == teams.length && `)`) || `, `}
        </Fragment>
      ))}
    </span>
  );
};
